import React from "react";

const Welcome = () => {
   return (
      <div className="grid place-content-center text-center h-[86vh] overflow-y-auto w-full text-5xl">
         <h3 className=" text-gray-300">Welcome to Personal</h3>
         <p className="text-primary text-6xl "> Dashboard</p>
      </div>
   );
};

export default Welcome;
